import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import "./GuideLines.style.less";

const { Text, Title } = Typography;

const GuideLines = () => {
  const { t } = useTranslation();
  return (
    <div className="guidelinesWrapper">
      <div className="guidelines" data-testid="guidelines">
        <Title level={3}>{t("decisionTool:guidelines.header")}</Title>
        <Text>{t("decisionTool:guidelines.guidelinesPre")}</Text>
        <ul>
          <li>{t("decisionTool:guidelines.guidelines1")}</li>
          <li>{t("decisionTool:guidelines.guidelines2")}</li>
          <li>{t("decisionTool:guidelines.guidelines3")}</li>
          <li>{t("decisionTool:guidelines.guidelines4")}</li>
        </ul>
        <Title level={3}>{t("decisionTool:notice.header")}</Title>
        <Text>{t("decisionTool:notice.noticeText")}</Text>
      </div>
    </div>
  );
};

export default GuideLines;
